import React, { useEffect, useMemo, useState } from 'react';

import { getUser, getWithLocale } from '../../utils/utils';
import { getActionsAll, getArticles, getSearchList, handleViewActivity } from '../../utils/requests';

import NearbyLocationList from '../nearbyLocationList';
import { DetailPageLayout } from '../detailPageLayout';

import ProjectDetailContent from './ProjectDetailContent';

export const ProjectDetailSection = ({ action, data, locale, t, breadcrumb, actionsTable }) => {
  const language = locale.toUpperCase();
  const [nearbyPropertyList, setNearbyPropertyList] = useState<any[]>([]);
  const [nearbyProjectList, setNearbyProjectList] = useState<any[]>([]);
  const [articleList, setArticleList] = useState<any[]>([]);
  const [actions, setActions] = useState<any[]>([]);

  const actionId = actionsTable?.data?.find((item) => item.action === action)?.id;

  const projectName = getWithLocale(data, 'project_Name', language);
  const address = [
    data[`Alley_${language}`],
    data[`Road_${language}`],
    data[`DISTRICT_NAME_${language}`],
    data[`AMPHUR_NAME_${language}`],
    data[`PROVINCE_NAME_${language}`],
    data[`POSTCODE`] || data[`POST_CODE`],
  ]
    .filter(Boolean)
    .join(' ')
    .trim();

  useEffect(() => {
    if (!data?.category_ID) return;

    const fetchNearby = async (options: {}, setList: (items: any[]) => void) => {
      try {
        const result = await getSearchList({
          page: 1,
          limit: 12,
          lat: data.project_Latitude,
          lng: data.project_Longitude,
          ...options,
        });

        setList(result?.data?.items || []);
      } catch (error) {
        console.error('Failed to fetch nearby:', error);
      }
    };

    fetchNearby({ categoryid: data.category_ID, sell: true, rent: true, propertystatus: true }, setNearbyPropertyList);
    fetchNearby({ sell: true, rent: true, projectstatus: true, projectonly: true }, setNearbyProjectList);
  }, [data?.category_ID]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const result = await getArticles(1, 2);
        setArticleList(result?.data || []);
      } catch (error) {
        console.error('Failed to fetch articles:', error);
      }
    };

    fetchArticles();
  }, [locale]);

  useEffect(() => {
    if (!data?.project_ID) return;
    const trackView = async () => {
      const user = await getUser();
      if (user) {
        handleViewActivity('project', Number(data?.project_ID), user.id);
      }
    };
    trackView();
  }, [data?.project_ID]);

  useEffect(() => {
    const getActions = async () => {
      try {
        const result = await getActionsAll();
        setActions(result?.data || []);
      } catch (error) {
        console.error('Failed to fetch actions:', error);
      }
    };

    getActions();
  }, [action]);

  const nearbyList = useMemo(() => {
    return Object.entries(data?.Nearby_Location || {}).map(([key, value], index) => ({
      key: index.toString(),
      label: getWithLocale(value?.[0], 'location_type_name', language),
      children: <NearbyLocationList data={value} locale={locale} />,
    }));
  }, [data, locale]);

  return (
    <DetailPageLayout
      action={action}
      t={t}
      breadcrumb={breadcrumb}
      header={{
        logoImage: data?.project_logo || data?.images?.[0]?.gallery_Images || '',
        title: projectName,
        address: address,
        saleCount: data?.saleCount || 0,
        rentCount: data?.rentCount || 0,
        detail: data,
      }}
      detail={<ProjectDetailContent data={data} t={t} locale={locale} nearbyList={nearbyList} />}
      data={data}
      nearbyList={nearbyList}
      locale={locale}
      categoryId={data?.category_ID || ''}
      actionId={actionId || ''}
      nearbyPropertyList={nearbyPropertyList}
      nearbyProjectList={nearbyProjectList}
      articleList={articleList}
      actions={actions}
    />
  );
};
